import React from 'react'
import { Route, Switch } from 'react-router-dom'
import { MetaData } from 'components/MetaData'
import { CmsPage as Default } from 'scenes/CmsPage'
import { PrivacyPolicy } from './scenes/PrivacyPolicy'
import { OurStory } from './scenes/OurStory'
import { Community } from './scenes/Community'
import { Faq } from './scenes/Faq'

export const CmsPage = () => {
  return (
    <>
      <MetaData
        type='CMS'
      />
      <Switch>
        <Route path='/policy' component={PrivacyPolicy} />
        <Route path='/story' component={OurStory} />
        <Route path='/community' component={Community} />
        <Route path='/faq' component={Faq} />
        <Route path='*' component={Default} />
      </Switch>
    </>
  )
}
